import React from 'react';
import { Link } from 'react-router-dom';

const PremiumHero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="fade-in">
                <h1 className="hero-title">
                  Take Control of Your Financial Future
                </h1>
                <p className="hero-subtitle">
                  Transform the way you manage your money with AI-powered insights, 
                  intelligent expense tracking, and personalized financial guidance 
                  designed for modern life.
                </p>
                <div className="hero-cta">
                  <Link to="/signup" className="btn btn-primary">
                    Get Started Free
                  </Link>
                  <Link to="/admin/dashboard" className="btn btn-outline">
                    View Demo
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hero-visual fade-in">
                <div className="dashboard-preview">
                  <div className="preview-card">
                    <div className="preview-header">
                      <div className="preview-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <div className="preview-title">Finova Dashboard</div>
                    </div>
                    <div className="preview-content">
                      <div className="preview-stats">
                        <div className="preview-stat">
                          <div className="preview-stat-value">$24,580</div>
                          <div className="preview-stat-label">Total Balance</div>
                        </div>
                        <div className="preview-stat">
                          <div className="preview-stat-value">$3,420</div>
                          <div className="preview-stat-label">Monthly Income</div>
                        </div>
                        <div className="preview-stat">
                          <div className="preview-stat-value">12%</div>
                          <div className="preview-stat-label">Savings Rate</div>
                        </div>
                      </div>
                      <div className="preview-chart">
                        <div className="chart-bars">
                          <div className="chart-bar" style={{height: '60%'}}></div>
                          <div className="chart-bar" style={{height: '80%'}}></div>
                          <div className="chart-bar" style={{height: '40%'}}></div>
                          <div className="chart-bar" style={{height: '90%'}}></div>
                          <div className="chart-bar" style={{height: '70%'}}></div>
                          <div className="chart-bar" style={{height: '85%'}}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="trust-indicators">
            <div className="trust-item">
              <i className="fas fa-users"></i>
              <span>Used by 10,000+ users</span>
            </div>
            <div className="trust-item">
              <i className="fas fa-shield-alt"></i>
              <span>Bank-level security</span>
            </div>
            <div className="trust-item">
              <i className="fas fa-star"></i>
              <span>4.9/5 user rating</span>
            </div>
            <div className="trust-item">
              <i className="fas fa-globe"></i>
              <span>50+ countries</span>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .hero-visual {
          position: relative;
        }
        
        .dashboard-preview {
          position: relative;
          max-width: 500px;
          margin: 0 auto;
        }
        
        .preview-card {
          background: white;
          border-radius: 16px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border: 1px solid #e2e8f0;
          overflow: hidden;
          transform: perspective(1000px) rotateY(-5deg);
          transition: transform 0.3s ease;
        }
        
        .preview-card:hover {
          transform: perspective(1000px) rotateY(0deg);
        }
        
        .preview-header {
          background: #f8fafc;
          padding: 16px 20px;
          border-bottom: 1px solid #e2e8f0;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .preview-dots {
          display: flex;
          gap: 6px;
        }
        
        .preview-dots span {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #cbd5e1;
        }
        
        .preview-dots span:first-child {
          background: #ef4444;
        }
        
        .preview-dots span:nth-child(2) {
          background: #f59e0b;
        }
        
        .preview-dots span:nth-child(3) {
          background: #10b981;
        }
        
        .preview-title {
          font-weight: 600;
          color: #1e293b;
          font-size: 14px;
        }
        
        .preview-content {
          padding: 24px;
        }
        
        .preview-stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          margin-bottom: 24px;
        }
        
        .preview-stat {
          text-align: center;
        }
        
        .preview-stat-value {
          font-size: 18px;
          font-weight: 700;
          color: #0b1f3a;
          margin-bottom: 4px;
        }
        
        .preview-stat-label {
          font-size: 12px;
          color: #64748b;
          font-weight: 500;
        }
        
        .preview-chart {
          background: #f8fafc;
          border-radius: 8px;
          padding: 16px;
          height: 80px;
        }
        
        .chart-bars {
          display: flex;
          align-items: end;
          justify-content: space-between;
          height: 100%;
          gap: 8px;
        }
        
        .chart-bar {
          flex: 1;
          background: linear-gradient(135deg, #0d9488 0%, #10b981 100%);
          border-radius: 4px 4px 0 0;
          min-height: 20px;
        }
        
        @media (max-width: 768px) {
          .hero-visual {
            margin-top: 3rem;
          }
          
          .preview-stats {
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;
          }
          
          .preview-stat-value {
            font-size: 14px;
          }
          
          .preview-stat-label {
            font-size: 10px;
          }
        }
      `}</style>
    </section>
  );
};

export default PremiumHero;
